<template>
  <div class="wen-xin-container">
    <i class="el-icon-s-opportunity"></i>
    <p>&nbsp;温馨提示：<span class="tips">*</span> 为必填项，信息填写越完善，越有助于用户提高购买几率</p>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.wen-xin-container {
  margin-top: 40px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #e7e7e7;
  .el-icon-s-opportunity,
  .tips {
    color: #ff0023;
  }
}
</style>
